import { useI18n } from 'vue-i18n'

/**
 * 多语言内容管理 Composable
 * 用于处理分类名称、产品名称等多语言内容的获取和管理
 */
export function useMultiLanguageContent() {
  const { locale } = useI18n()
  
  // 获取多语言内容 - 支持多种语言格式
  const getMultiLanguageContent = (content, defaultContent = '') => {
    if (!content) return defaultContent
    
    // 如果内容已经是字符串，直接返回
    if (typeof content === 'string') {
      return content
    }
    
    // 如果内容是对象，根据当前语言获取对应版本
    if (typeof content === 'object') {
      // 尝试获取当前语言的确切匹配 (如 'en-US')
      if (content[locale.value]) {
        return content[locale.value]
      }
      
      // 尝试获取当前语言的主要语言代码 (如 'en' 而不是 'en-US')
      const mainLang = locale.value.split('-')[0]
      if (content[mainLang]) {
        return content[mainLang]
      }
      
      // 尝试获取英文版本 (常见替代)
      if (content['en']) {
        return content['en']
      }
      
      // 尝试获取中文版本 (默认)
      if (content['zh'] || content['zh-CN']) {
        return content['zh'] || content['zh-CN']
      }
      
      // 返回默认内容
      return defaultContent
    }
    
    return defaultContent
  }

  // 获取分类的多语言名称
  const getCategoryName = (category) => {
    if (!category) return ''
    
    // 优先使用多语言名称，其次使用普通名称
    return getMultiLanguageContent(category.multilangName, category.name || category.nameKey || '')
  }

  // 获取产品的多语言名称
  const getProductName = (product) => {
    if (!product) return ''
    
    // 优先使用多语言名称，其次使用普通名称
    return getMultiLanguageContent(product.multilangName, product.name || '')
  }

  // 获取产品的多语言描述
  const getProductDescription = (product) => {
    if (!product) return ''
    
    // 优先使用多语言描述，其次使用普通描述
    return getMultiLanguageContent(product.multilangDescription, product.description || '')
  }

  return {
    getMultiLanguageContent,
    getCategoryName,
    getProductName,
    getProductDescription
  }
}